<script>
export const group = 'Bottom'
</script>

<script setup>
import StopwatchPill from './shared/StopwatchPill.vue'
import TextSlideUpFade from './text_animations/TextSlideUpFade.vue'
const gsapTimeline = useGsapTimeline()

defineProps({
  item: Object,
})

const timelineTitleAbove = ref(null)
const timelineTitleAboveOut = ref(null)
const timelinePill = ref(null)
const timelinePillOut = ref(null)
const timelineTitleBelow = ref(null)
const timelineTitleBelowOut = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'Stopwatch' })
    .add(timelineTitleAbove)
    .add(timelinePill, `<${frames(16)}`)
    .add(timelineTitleBelow, `<${frames(2)}`)
})

const { onDisappear } = useDisappearable()
onDisappear(async () => {
  await gsapTimeline({ name: 'StopwatchSmall - End' }).add(timelineTitleBelowOut.value(), '<').add(timelinePillOut.value(), '<').add(timelineTitleAboveOut.value(), '<')
})
</script>

<template>
  <div>
    <div class="flex flex-col items-start text-white text-7xl font-bold gap-6">
      <TextSlideUpFade class="text-shadow-glow" :text="item.properties.titleAbove || ''" @timeline="timelineTitleAbove = $event" @timelineOut="timelineTitleAboveOut = $event" />
      <StopwatchPill
        class="text-6xl !h-24"
        :stopwatch="item.enrichment.stopwatch"
        :showDays="!item.properties.showDaysAsHours"
        @timeline="timelinePill = $event"
        @timelineOut="timelinePillOut = $event"
      />
      <TextSlideUpFade class="text-shadow-glow" :text="item.properties.titleBelow || ''" @timeline="timelineTitleBelow = $event" @timelineOut="timelineTitleBelowOut = $event" />
    </div>
  </div>
</template>
